import Swiper from 'swiper/bundle'

export default class Cards {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    this.slider = this.el.querySelector('.swiper')
    if (!this.slider) return

    // Slider uniquement sous 992px, 3 colonnes fixes au-dessus
    this.mq = window.matchMedia('(max-width: 991.98px)')
    this.mq.addEventListener('change', () => this.toggle())
    this.toggle()
  }

  toggle() {
    if (this.mq.matches && !this.swiper) this.create()
    else if (!this.mq.matches && this.swiper) this.destroy()
  }

  create() {
    // Défilement continu et linéaire : delay 0 + vitesse longue + easing linear (cf. style.sass)
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      speed: 10000,
      allowTouchMove: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    })
  }

  // Supprime aussi les slides clonés par le loop pour retrouver les 3 colonnes d'origine
  destroy() {
    this.swiper.destroy(true, true)
    this.swiper = null
  }
}
